<template>
  <v-container class="mt-10">
    <v-row justify="center" class="mb-6">
      <p class="text-h4">Partners</p>
    </v-row>

    <v-row justify="center">
      <v-col
        v-for="logo in siteLogos"
        :key="logo.label"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        class="d-flex justify-center align-center"
      >
        <v-card
          class="logo-card ma-2"
          flat
          :href="logo.url"
          target="_blank"
          :ripple="!!logo.url"
        >
          <v-card-text class="d-flex justify-center align-center">
            <v-img
              v-if="logo.img"
              :src="logo.img"
              :alt="logo.label"
              class="logo-image"
              contain
              :height="$vuetify.display.smAndDown ? '50' : '70'"
            />
            <div v-else>
              <v-sheet class="text-center pa-2">
                <p class="aqnz">{{ logo.label }}</p>
              </v-sheet>
            </div>
          </v-card-text>
          <v-card-subtitle class="text-center pt-0">{{
            logo.label
          }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import macLabLogo from "@/assets/MacLab-logo.svg";
import mfaLogo from "@/assets/mfaLogo.jpg";
import sanfordLogo from "@/assets/Sanford-logo-rgb.svg";
import whakatoheaLogo from "@/assets/whakatoheaMussel_open_ocean.svg";
import tdcLogo from "@/assets/tdc_logo.svg";
import mbariLogo from "@/assets/mbari-logo-full.svg";

export default {
  data() {
    return {
      show: false,
      tascamLogos: [
        { url: "https://www.maclab.co.nz", img: macLabLogo },
        {
          url: "https://www.tasman.govt.nz/",
          img: tdcLogo,
        },
        {
          url: "https://www.mbari.org",
          img: mbariLogo,
        },
      ],
      logos: [
        { url: "https://www.maclab.co.nz", img: macLabLogo },
        {
          url: "https://www.marinefarming.co.nz",
          img: mfaLogo,
        },
        {
          url: "http://www.whakatohea.co.nz",
          img: whakatoheaLogo,
        },
        {
          url: "https://www.sanford.co.nz",
          img: sanfordLogo,
        },
      ],
    };
  },
  computed: {
    site: function () {
      return this.$store.state.site;
    },
    siteLogos: function () {
      return this.site == "Tasman Bay" ? this.tascamLogos : this.logos;
    },
  },
};
</script>

<style scoped>
.logo-card {
  width: 100%;
  max-width: 200px;
  height: 120px;
  transition: transform 0.2s;
}

.logo-card:hover {
  transform: scale(1.05);
}

.logo-image {
  max-width: 180px;
  transition: filter 0.2s;
}

.logo-image:hover {
  filter: brightness(1.1);
}

.aqnz {
  font-family: "Karbon" !important;
  font-weight: 200;
  font-size: 16px;
  text-align: center;
  align-self: center;
  background-color: black;
  color: white;
  padding: 0.5em;
}

/* Add responsive adjustments */
@media (max-width: 600px) {
  .logo-card {
    height: 100px;
    max-width: 160px;
  }

  .logo-image {
    max-width: 140px;
  }
}

@media (min-width: 1904px) {
  .logo-card {
    max-width: 250px;
    height: 140px;
  }

  .logo-image {
    max-width: 220px;
  }
}
</style>
